export function brightenKeyWord(val: string, keyWord: string, className: string) {
    if (keyWord.length > 0) {
      let keywordArr = keyWord.split("");
      val = val + "";
      keywordArr.forEach((item) => {
        if (val.indexOf(item) !== -1 && item !== "") {
          val = val.replace(
            new RegExp(item, "g"),
            `<span class="${className}">` + item + "</span>"
          );
        }
      });
      return val;
    } else {
      return val;
    }
  }